//@ts-nocheck
import { createAsyncThunk } from '@reduxjs/toolkit';

import DeviceProps from '@magnus/react-native-device-props';

import Analytics from '@web-solutions/module-analytics';

import Billing from '@web-solutions/module-billing';

import { changePurchaseTokenIdAction, setIsOpenErrorPopup } from 'core/store/billing/actions';

import { processPayment } from '../../api/payment';
import { recordTransaction } from '../../api/transaction';

import { sendEmail } from 'core/upsale/api/send-email';
import { nextStep, setIsLoading } from 'core/upsale/store';
import type { ProductDetails } from 'core/store/billing/selectors';
import { PaymentProcessorRef } from 'core/payment/payment-processor-provider/components/payment-processor';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Purchase } from 'core/upsale/api/types';

interface IPurchaseThunk extends ProductDetails {
  ref?: React.RefObject<PaymentProcessorRef | null>;
  handleNext?: () => void;
  three_d_secure_action_result_token_id?: string;
  attempt?: number | null;
  setAttempt?: (val: number | null) => void;
}

//@ts-ignore
export const handlePurchaseThunk = createAsyncThunk<unknown, IPurchaseThunk>(
  'purchase/handlePurchase',
  //@ts-ignore
  async (params: IPurchaseThunk, { getState, dispatch, rejectWithValue }) => {
    const {
      recurlyId,
      isDiscount,
      messageTemplate,
      productCode,
      amount,
      ref,
      ladder,
      handleNext,
      three_d_secure_action_result_token_id,
      attempt = null,
      setAttempt,
      priceUpsaleUSD,
      vatPercent,
    } = params;

    dispatch(setIsLoading(true));
    const status = isDiscount ? 'discount' : 'main';

    // @ts-ignore
    const { purchase: rcPurchase } = getState().billing;
    // @ts-ignore
    const { locale } = getState().locale;
    const next = handleNext || (() => dispatch(nextStep()));

    const purchaseData: Purchase = { email: rcPurchase?.email, token_id: rcPurchase?.token_id };

    const amountToBuy = attempt === null ? amount : (ladder?.[attempt].amount ?? amount);

    const productToBuy = attempt === null ? recurlyId : (ladder?.[attempt].recurlyId ?? recurlyId);

    const analyticsAttempt = attempt !== null ? attempt + 1 : 0;

    try {
      const idfm = await DeviceProps.getIDFM();
      const threeDSecureActionTokenId = three_d_secure_action_result_token_id;
      const chargeInvoice = await processPayment(
        //@ts-ignore
        purchaseData,
        productToBuy,
        threeDSecureActionTokenId
      );

      await recordTransaction(chargeInvoice, idfm, purchaseData);

      Analytics.trackEvent('upsale', 'purchase_success', {
        status,
        product: productCode,
        amount: priceUpsaleUSD,
        productId: productToBuy,
        attempt: analyticsAttempt,
        ...(vatPercent && { VAT: vatPercent, value_total: amount }),
      });

      if (messageTemplate && rcPurchase?.email) {
        try {
          await sendEmail(rcPurchase?.email, `${messageTemplate}_${locale}`);
        } catch (e) {
          Analytics.trackEvent('server_smt_email_send', 'error', {
            // @ts-ignore
            error: e?.message || 'Something went wrong',
          });
        }
      }

      next();

      return chargeInvoice;
    } catch (error: any) {
      const axiosError = getAxiosErrorMessage(error);
      Analytics.trackEvent('upsale', 'purchase_error', {
        err: axiosError,
        status,
        product: productCode,
        amount: amountToBuy,
        productId: productToBuy,
        attempt: analyticsAttempt,
      });
      const nextAttempt = attempt === null ? 0 : attempt + 1;

      if (error.isProcessPaymentError && ladder?.length && nextAttempt <= ladder?.length - 1) {
        if (nextAttempt < ladder.length && setAttempt) {
          setAttempt(nextAttempt);
          //@ts-ignore
          const ladderResult = await dispatch(
            handlePurchaseThunk({ ...params, attempt: nextAttempt, ...ladder[nextAttempt] })
          );

          return ladderResult.payload;
        } else {
          if (
            error.message &&
            error.message !== 'Your card must be authenticated with 3-D Secure before continuing.'
          ) {
            toast.error(axiosError.message);
            dispatch(setIsOpenErrorPopup(true));
          }
        }
      } else {
        if (
          error.message &&
          error.message !== 'Your card must be authenticated with 3-D Secure before continuing.'
        ) {
          toast.error(axiosError.message);
          dispatch(setIsOpenErrorPopup(true));
        }
      }
      return rejectWithValue(error);
    } finally {
      dispatch(setIsLoading(false));
    }
  }
);

export const changePurchaseTokenIdThunk = createAsyncThunk(
  'purchase/change_token_id_in_db',
  async (tokenId: string, { dispatch, getState, rejectWithValue }) => {
    try {
      dispatch(changePurchaseTokenIdAction(tokenId));

      await Billing.saveTokenRecurly(tokenId);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const getAxiosErrorMessage = (error: unknown): { message: string; code?: string | number } => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data,
      code = error.response?.status;

    if (data) {
      if (typeof data === 'string') return { message: data, code };
      if (Array.isArray(data)) return { message: data.join(', '), code };
      if (typeof data === 'object') {
        const error =
          data.message || data.error || data.detail || data.errors || JSON.stringify(data);
        return { message: Array.isArray(error) ? error.join(', ') : error, code };
      }
    }

    return { message: error.message, code };
  }

  return { message: 'Something went wrong please try again' };
};
